import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6985a551921dc90014e18177/website_project/src/app/team/TeamPageClient.tsx");
